<ng-container *ngIf="form" [formGroup]="form">
	<div class="u-row">
		<tvcore-input class="u-col--8 u-col-sm--12" [label]="TRANSLATIONS['STREET']" name="street" [showErrors]="showErrors">
			<tvcore-input-error name="required">{{ TRANSLATIONS['ERRORS']['STREET_REQUIRED'] }}</tvcore-input-error>
		</tvcore-input>

		<tvcore-input class="u-col--2 u-col-sm--6" [label]="TRANSLATIONS['NUMBER']" name="number" [ltr]="true" [showErrors]="showErrors">
			<tvcore-input-error name="required">{{ TRANSLATIONS['ERRORS']['NUMBER_REQUIRED'] }}</tvcore-input-error>
		</tvcore-input>

		<tvcore-input class="u-col--2 u-col-sm--6" [label]="TRANSLATIONS['BOX']" name="box" [showErrors]="showErrors"></tvcore-input>
	</div>

	<div class="u-row">
		<tvcore-input class="u-col--4 u-col-sm--12" [label]="TRANSLATIONS['POSTAL_CODE']" name="postalCode" [showErrors]="showErrors">
			<tvcore-input-error name="required">{{ TRANSLATIONS['ERRORS']['POSTAL_CODE_REQUIRED'] }}</tvcore-input-error>
		</tvcore-input>

		<tvcore-input class="u-col--8 u-col-sm--12" [label]="TRANSLATIONS['CITY_NAME']" name="cityName" [showErrors]="showErrors">
			<tvcore-input-error name="required">{{ TRANSLATIONS['ERRORS']['CITY_NAME_REQUIRED'] }}</tvcore-input-error>
		</tvcore-input>
	</div>

	<div class="c-aca-result-box" [class.c-aca-result-box--hidden]="status === 'selected'" [class.c-aca-result-box--error]="showErrors && status !== 'selected'">
		<div *ngIf="status === 'loading'" class="c-aca-result-box__searching">
			<tvcore-icon name="loader"></tvcore-icon>

			{{ TRANSLATIONS['SEARCHING'] }}
		</div>

		<ng-container *ngIf="addresses$ | async as addresses">
			<p class="u-text--sm u-text--bold">{{ TRANSLATIONS['RESULTS'] }}</p>

			<div *ngFor="let address of addresses" class="c-aca-result-box__item" (click)="selectAddress(address)">
				<ng-container *ngIf="address.street">{{ address.street }}, </ng-container>{{ address.postalCode }} {{ address.cityName }}
			</div>

			<p *ngIf="addresses.length < 1">{{ TRANSLATIONS['NO_RESULTS'] }}</p>
		</ng-container>
	</div>

	<p *ngIf="showErrors && status !== 'selected'" class="u-text--sm u-text--error u-m-top--tiny u-m-bottom--md">{{ TRANSLATIONS['ERRORS']['SELECT_RESULT'] }}</p>
</ng-container>
